import { JsonService } from './../service/json.service';
import { JobService } from './../service/job.service';
import { Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { dreamjobs_txt, espectador_txt } from '../texts/text';


@Component({
  selector: 'app-offers-micro-sites',
  templateUrl: './offers-micro-sites.component.html',
  styleUrls: ['./offers-micro-sites.component.css']
})
export class OffersMicroSitesComponent implements OnInit {
  companyName = '';
  dir_name = '';
  titleCompany = '';
  logo = '';
  txt: any;
  sizeAll: number;
  jobsAll: any;
  pagesAll: number;
  maxAll = 6;
  onloadingAll = true;
  pageAll = 1;
  totalAll = 1;

  video_dir = 'assets/images/dreamjobs/video.mp4';

  sizeUrgent: number;
  jobsUrgent: any;
  pagesUrgent: number;
  maxUrgent = 6;
  onloadingUrgent = true;
  pageUrgent = 1;
  totalUrgent = 1;
  searchAll = '';
  searchCompany = '';
  searchUrgent = '';

  sizeCompany: number;
  jobsCompany: any;
  jobsCompanySlice: any;
  pagesCompany: number;
  maxCompany = 6;
  onloadingCompany = true;
  pageCompany = 1;
  totalCompany = 1;

  urlJob = "https://user.dreamjobs.com.co/job/";

  latitude = 4.6773589;
  longitude = -74.0601957;
  message = 'Obteniendo tu localización, esto puede tardar unos segundos';
  geolocationPosition: any;
  errorMessage: string;
  json: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private jobService: JobService,
    private jsonService: JsonService
  ) { }


   ngOnInit() {
    console.log(this.video_dir);
    this.jsonService.getJSON().then(
      (result: any) => {
        console.log(result);
        this.jobsAll = result.all;
        this.jobsCompanySlice = result.company.slice(0, 3);
        this.jobsUrgent = result.urgents;
      }, (err) => {
        this.errorMessage = 'Error';
      }
    );
    this.route.params.subscribe(params => {
      this.companyName = params['companyName'];
      this.dir_name = 'assets/images/' + this.companyName + '/';
        switch (this.companyName) {
          case 'dreamjobs':
             this.companyName = this.companyName;
             this.titleCompany = 'Dreamjobs';
             this.txt = dreamjobs_txt;
             this.video_dir = 'assets/images/' + this.companyName + '/video.mp4';
          break;
          case 'elespectador':
             this.companyName = this.companyName;
             this.titleCompany = 'El Espectador';
             this.txt = espectador_txt;
             this.video_dir = 'assets/images/' + this.companyName + '/video.mp4';
          break;
          default:
             this.companyName = 'dreamjobs';
             this.titleCompany = 'Dreamjobs';
          break;
        }
    });

    // if (localStorage.getItem('location-lat') && localStorage.getItem('location-lng')) {
    //   this.longitude = parseFloat( localStorage.getItem('location-lng') );
    //   this.latitude = parseFloat( localStorage.getItem('location-lat') );
    //   this.message = 'Buscando ofertas';
    //   this.JobCompany(1);
    //   this.JobAll(1);
    //   this.JobUrgent(1);
    //   this.geoLocation(1);
    // } else {
      //this.JobCompany(1);
      //this.JobAll(1);
      //this.JobUrgent(1);
      //this.geoLocation(1);
    // }
  }

  searchFnAll() {
    this.JobAll(1);
  }
  searchFnCompany() {
    this.JobCompany(1);
  }
  searchFnUrgent() {
    this.JobUrgent(1);
  }

  geoLocation(tries) {
    this.message = this.message + '.';

      if (window.navigator && window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
            position => {
                this.geolocationPosition = position;
                localStorage.setItem('location-lng', this.geolocationPosition.coords.longitude);
                localStorage.setItem('location-lat', this.geolocationPosition.coords.latitude);
                this.latitude = this.geolocationPosition.coords.latitude;
                this.longitude = this.geolocationPosition.coords.longitude;
                console.log(position);
                this.message = 'Buscando ofertas';
                this.JobCompany(1);
                this.JobAll(1);
                this.JobUrgent(1);
            },
            error => {
                switch (error.code) {
                    case 1:
                        console.log('Permission Denied');
                        break;
                    case 2:
                        console.log('Position Unavailable');
                        break;
                    case 3:
                        console.log('Timeout ' + tries);
                        this.geoLocation(tries + 1);
                        break;
                }
            },
            {
              enableHighAccuracy: false,
              timeout: 10000
            }
        );
      };
    console.log(this.longitude);
    console.log(this.latitude);
  }

  isCompany(name) {
        return this.dir_name + name;
   }

  getImage(name) {
    return 'url("assets/images/' + this.companyName + '/' + name + '")';
  }


  getStyle() {
    const style = {
      // CSS Dreamjobs
      'navbar-custom-dj': this.companyName == 'dreamjobs',
      'bg-dark-dj': this.companyName == 'dreamjobs',
      'btn.btn-d-dreamjobs': this.companyName == 'dreamjobs',
      // CSS El Espectador
      'navbar-custom-elespectador': this.companyName == 'elespectador',
      'btn.btn-d-elespectador': this.companyName == 'elespectador',
      // 'bg-dark-elespectador':this.companyName == 'dreamjobs',
    };
    return style;
  }

  JobAll(page) {
    if (this.searchAll == ''){
      this.jobService.getJobAll4(this.latitude, this.longitude, 0, page)
      .then((result: any) => {
        console.log(result);
          this.jobsAll = result.jobs;
          this.totalAll = result.pagination.total;
          this.pagesAll = result.pagination.pages;
          this.maxAll = result.pagination.pageCount;
          this.onloadingAll = false;
          console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );
    }else{
      console.log("entra qui")
      this.jobService.getJobAll4(this.latitude, this.longitude, 0, page, this.searchAll)
      .then((result: any) => {
        console.log(result);
          this.jobsAll = result.jobs;
          this.totalAll = result.pagination.total;
          this.pagesAll = result.pagination.pages;
          this.maxAll = result.pagination.pageCount;
          this.onloadingAll = false;
          console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );
    }
  }

  JobUrgent(page) {
    if (this.searchUrgent == ''){
      this.jobService.getJobAll4(this.latitude, this.longitude, 1, page)
      .then((result: any) => {
        console.log(result);
          this.jobsUrgent = result.jobs;
          this.totalUrgent = result.pagination.total;
          this.pagesUrgent = result.pagination.pages;
          this.maxUrgent = result.pagination.pageCount;
          this.onloadingUrgent = false;
          console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );

    }else{
      this.jobService.getJobAll4(this.latitude, this.longitude, 1, page, this.searchUrgent)
      .then((result: any) => {
        console.log(result);
          this.jobsUrgent = result.jobs;
          this.totalUrgent = result.pagination.total;
          this.pagesUrgent = result.pagination.pages;
          this.maxUrgent = result.pagination.pageCount;
          this.onloadingUrgent = false;
          console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );

    }
    // this.jobService.getJobAll(this.geolocationPosition.coords.latitude, this.geolocationPosition.coords.longitude, 0, this.pageAll)

  }

  JobCompany(page) {
    const page_begin = ( ( page - 1 ) * 3 );
    let page_end = page_begin + 3;
    if (this.searchCompany == ''){
      this.jobService.getJobCompany(this.latitude, this.longitude, page)
      .then((result: any) => {
          this.jobsCompany = result.companies;
          this.totalCompany = result.company_total;

          if (page_end > this.totalCompany) {
            page_end = this.totalCompany;
          }
          this.jobsCompanySlice = this.jobsCompany.slice(page_begin, page_end);
          //this.pagesCompany = result.pagination.pages;
          this.pageCompany = this.pageCompany;
          //this.maxCompany = result.pagination.pageCount;
          this.onloadingCompany = false;
          console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
    );
    }else{
      this.jobService.getJobCompany(this.latitude, this.longitude, page, this.searchCompany)
      .then((result: any) => {
          this.jobsCompany = result.companies;
          this.totalCompany = result.company_total;
          if (page_end > this.totalCompany) {
            page_end = this.totalCompany;
          }
          this.jobsCompanySlice = this.jobsCompany.slice(page_begin, page_end);
          //this.pagesCompany = result.pagination.pages;
          this.pageCompany = this.pageCompany;
          //this.maxCompany = result.pagination.pageCount;
          this.onloadingCompany = false;
          console.log (result.jobs);
        }, (err) => {
          this.errorMessage = <any>Error
        }
      );
    }
}

  goToJob(uuid) {
    this.router.navigateByUrl('https://user.dreamjobs.com.co/job/' + uuid);
  }

  getUpdateAll(event) {
    console.log(event);
    this.JobAll(event);
  }

  getUpdateUrgent(event) {
    console.log(event);
    this.JobUrgent(event);
  }

  getUpdateCompany(event) {
    console.log(event);
    const page_begin = ( ( event - 1 ) * 6 );
          let page_end = page_begin + 6;
          if (page_end > this.totalCompany) {
            page_end = this.totalCompany;
          }

          this.jobsCompanySlice = this.jobsCompany.slice(page_begin, page_end);
  }



}



// WEBPACK FOOTER //
// ./src/app/offers-micro-sites/offers-micro-sites.component.ts